import { defineComponent as _defineComponent } from 'vue'

import LexonTooltipComponent from '@/components/forms/fields/LexonTooltip/LexonTooltipComponent.vue'
import PhoneListComponent from '@/components/widgets/ExpedientWidgets/ExpedientSummaryWidget/PhoneListComponent.vue'
import { Icons } from '@/icons/icons'
import { sanitizeHtml } from '@/helpers/html'

interface DataItem {
  name: string
  phone?: string
}

interface ItemData {
  label: string
  data: string | DataItem[]
}

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneListTooltip',
  props: {
    item: { type: Object, required: true },
    index: { type: Number, required: true },
    isTruncated: { type: Boolean, required: true }
  },
  emits: ['setRef'],
  setup(__props: any, { emit }) {

const props = __props as {
  item: ItemData
  index: number
  isTruncated: boolean
};



// DATA
const icon = {
  phone: Icons.CALL
}

// EMITS


// METHODS
const onSetRef = (el: any, index: number) => {
  if (el) {
    emit('setRef', el, index)
  }
}

const generateTooltipMessage = (item: ItemData) => {
  if (Array.isArray(item.data)) {
    const listItems = item.data.map(createPhoneListItem).join('')
    return `<ul class="tooltip-phone-list">${listItems}</ul>`
  }
  return ''
}

const createPhoneListItem = (subItem: DataItem) => {
  const sanitizedName = sanitizeHtml(subItem.name)
  const sanitizedPhone = subItem.phone ? sanitizeHtml(subItem.phone) : ''

  return `<li class="phone-list-item">
    <span class="tooltip-phone-name">${sanitizedName}</span>
    ${createPhoneDisplay(sanitizedPhone)}
  </li>`
}

const createPhoneDisplay = (phoneNumber: string) => {
  if (!phoneNumber) return ''

  return `<span class="tooltip-phone-container">
    <a href="tel:${phoneNumber}" class="tooltip-phone-link">
      <i class="${icon.phone} tooltip-phone-icon"></i>
      <span class="tooltip-phone-number">${phoneNumber}</span>
    </a>
  </span>`
}

return { __sfc: true,props, icon, emit, onSetRef, generateTooltipMessage, createPhoneListItem, createPhoneDisplay, LexonTooltipComponent, PhoneListComponent }
}

})